import React from 'react';
import LandingPageLayout from "../layout/LandingPageLayout";
import LandingPageCollapse from "./LandingPageCollapse";
import LandingPageSectionTitle from './LandingPageSectionTitle';

const LandingPageCollapses = () => {
    const collapsesData = [
        {
            header: 'O QUE SÃO MILHAS AÉREAS?',
            content: 'Milhas são uma pontuação dada pelos programas de fidelidade das companhias aéreas a seus clientes. Um benefício exclusivo para fortalecer o relacionamento entre essas empresas e as pessoas que utilizam seus serviços.'
        },
        {
            header: 'Qual é a diferença entre pontos do cartão e milhas aéreas?',
            content: 'São a mesma coisa. Ponto é o nome que, geralmente, os programas de fidelidade de bancos e cartões de crédito utilizam. Já a maior parte dos programas das companhias aéreas adotam o termo milha.'
        },
        {
            header: 'Como as milhas funcionam?',
            content: 'Os clientes dos programas de fidelidade acumulam pontos no pagamento da fatura do cartão de crédito. Esses pontos podem ser transferidos para os programas das companhias aéreas para se transformarem em milhas, que podem ser vendidas na MaxMilhas ou ainda trocadas por passagens e produtos de parceiros.'
        },
        {
            header: 'Como consigo acumular milhas?',
            content: 'É possível acumular milhas a cada compra feita no cartão de crédito, na aquisição de pontos nos próprios programas de fidelidade, na assinatura de clubes de vantagens, em bônus de transferências para os programas de fidelidade e nas viagens de avião que você faz.'
        },
        {
            header: 'Onde posso me cadastrar?',
            content: 'Você pode se cadastrar nos programas de fidelidade dos cartões de crédito, como Livelo (programa de fidelidade criado pelo Banco do Brasil e Bradesco), Sempre Presente (Itaú), Pontos Caixa (Caixa) e Esfera (Santander). Depois, para transformar suas milhas em viagens ou vendê-las, você deve se cadastrar nos programas de fidelidade das principais companhias aéreas do Brasil: Multiplus (Latam), Smiles (Gol) e Tudo Azul (Azul).'
        },
        {
            header: 'Como faço para transformar pontos do cartão em milhas aéreas?',
            content: 'Quando você acumula pontos no pagamento da fatura do cartão de crédito, o primeiro passo é escolher um dos programas de fidelidade das companhias aéreas e transferir esses pontos para transformá-los em milhas.'
        },
        {
            header: 'Onde vender milhas?',
            content: 'Existem empresas especializadas na emissão de passagens aéreas com milhas para terceiros. A MaxMilhas é pioneira no segmento e, desde 2013, lidera esse mercado. A plataforma intermedia a venda de suas milhas sem cobrar nada por isso e faz todo o processo de emissão com muito mais comodidade e segurança para o vendedor. '
        },
        {
            header: 'Para qual programa de fidelidade devo transferir minhas milhas?',
            content: 'A escolha do programa de fidelidade ideal para você depende do seu perfil. Se o seu objetivo é vender milhas, nossa dica é verificar o valor médio de venda das milhas de cada programa de fidelidade no site da MaxMilhas. Outro fator que pode ser decisivo são as promoções de bônus no momento da transferência de pontos para o programa de fidelidade da companhia. Você pode ganhar até o dobro de milhas nessas transferências. '
        },
        {
            header: 'Quando transferir milhas?',
            content: 'É muito comum os programas de fidelidade realizarem promoções que oferecem bônus nas transferências de pontos ou na compra de produtos e serviços. Acompanhe os sites dos programas e de seus parceiros, se inscreva para receber novidades, aproveite os períodos de promoções para transferência de pontos e aumente ainda mais suas possibilidades de acúmulo de milhas.'
        },
        {
            header: 'Quando as milhas expiram?',
            content: 'Cada programa de fidelidade tem um prazo diferente para que as milhas acumuladas comecem a expirar. Essa validade depende da forma de acúmulo daquelas milhas e da sua categoria no programa e pode variar de 6 meses a prazos ilimitados. '
        },
    ]

    return (
        <LandingPageLayout classAdd='offers-landing-page-collapses'>
            <LandingPageSectionTitle 
                strongText="Tire todas as suas" 
                text="dúvidas sobre milhas" 
            />
            
            <div className="offers-landing-page-collapses__container">
                {
                    collapsesData.map((widget, index) =>
                        <LandingPageCollapse
                            key={index}
                            number={index + 1}
                            header={widget.header}
                            content={widget.content}
                        />
                    )
                }
            </div>
        </LandingPageLayout>
    );
};

export default LandingPageCollapses;